import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { noInternetMsg, optionalHolidayLimitExceed, saveFailedMsg, savemsg, saveWarningMsg, serverMsg } from "../../config/messageconstant";
import { apiGet, apiPost } from "../../utils/api_service";
import { OptionalHolidayJson } from "../../DynamicFormsJson/Transaction/optionalHoliday";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { getAvailableOptionalHolidays } from "../../Slice/year.slice";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { Paper } from "@mui/material";
import { mandatoryCheck } from "../../config/ValidationCheck";
import { getBelowSalesTeamList } from "../../Slice/salesExecutive.slice";

class AddOptionalHolidayForUnderTeam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                salesTeamDetail: this.props.salesTeamList?.salesExecutiveBelowTeam,
                optionalHolidayDetail: this.props.optionalHolidayList?.optionalHoliday,
            },
            fieldData: {},
            formErrors: {},
            reponseData: [],
        };
    }
    componentWillReceiveProps(nextProps) {

        if (this.props.salesTeamList !== nextProps.salesTeamList) {
            if (
                this.props.salesTeamList?.salesExecutiveBelowTeam !== nextProps.salesTeamList?.salesExecutiveBelowTeam
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        salesTeamDetail: nextProps.salesTeamList?.salesExecutiveBelowTeam,
                    },
                });
            }
        }


        if (this.props.optionalHolidayList !== nextProps.optionalHolidayList) {
            if (
                this.props.optionalHolidayList?.optionalHoliday !== nextProps.optionalHolidayList?.optionalHoliday
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        optionalHolidayDetail: nextProps.optionalHolidayList?.optionalHoliday,
                    },
                });
            }
        }
    }

    async componentDidMount() {
        const { getBelowSalesTeamList, showLoador, showNotification } =
            this.props;
        if (navigator.onLine) {

            showLoador({ loador: true });
            await getBelowSalesTeamList({ salesTeamId: "", flag: 0 }).then(({ success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });

        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }



    getListById = async (data) => {
        const {
            getAvailableOptionalHolidays,
            showLoador,
            showNotification,
        } = this.props;
        if (navigator.onLine) {

            if (data.salesTeam && data.salesTeam != "") {
                showLoador({ loador: true });
                await getAvailableOptionalHolidays({ salesTeamId: data.salesTeam }).then(({ response, success }) => {
                    if (!success) {
                        showNotification({ msg: "Holiday struture not assigned to sales team!", severity: "error" });
                    } else {
                        this.setState({ reponseData: response });
                    }
                });
                showLoador({ loador: false });
            }
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };


    onFormSave = () => {
        const { fieldData, reponseData } = this.state;
        const { showNotification, showLoador } = this.props;

        if (this.checkValidationOnSubmit()) {
            const detailId = reponseData.find((row) => row.id == fieldData?.optionalHolidayDetailId);

            if (detailId?.holidayType == 1 &&
                detailId?.optionalHolidaysTaken == detailId?.optionalLimit
            ) {
                return showNotification({ msg: optionalHolidayLimitExceed, severity: "error" });
            }

            let dataToSave = {
                holidayYearMaster: { id: reponseData[0].holidayYearId },
                holidayStructureDetail: { id: detailId?.id },
                salesTeam: { id: fieldData?.salesTeam },
            }

            swal({
                title: "Are you sure?",
                text: saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    apiPost({
                        url: endpoint.holidayTransaction,
                        postBody: dataToSave,
                    }).then(({ success }) => {
                        showLoador({ loador: false });
                        if (success) {
                            showNotification({
                                msg: savemsg,
                            });
                            this.props.navigate("/optional-holiday-under-team")
                        } else {
                            showNotification({
                                msg: saveFailedMsg,
                                severity: "error",
                            });
                        }
                    });
                }
            });
        }
    }


    checkValidationOnSubmit = () => {
        const { fieldData } = this.state;
        const mandatoryCheckErrors = mandatoryCheck({
            fieldData,
            fieldMeta: OptionalHolidayJson.fieldMetaForSalesTeam,
        });
        this.setState({
            formErrors: mandatoryCheckErrors.formErrors,
        });

        return mandatoryCheckErrors.formValid;
    };


    onDataChange = (fieldName, newValue) => {
        const { fieldData } = this.state;
        const dataToSearch = {};
        const dataToReset = { ...this.state.fieldData };
        let listError = false;
        OptionalHolidayJson.fieldMetaForSalesTeam.map((currentField) => {
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");

                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });

                this.getListById(dataToSearch);
            }
            if (currentField.getDate && currentField.dataKey === fieldName) {
                dataToReset[currentField.getDate] = newValue.add(365, "day");
            }
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");
                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });
            }
            if (currentField.getListFrom) {
                const masterKeyList = currentField.getListFrom.split(",");
                masterKeyList.map((key) => {
                    if (key == fieldName && dataToReset[key]) {
                        delete dataToReset[currentField.dataKey];
                    }
                });
            }
            if (
                !listError &&
                fieldData[currentField.dataKey] &&
                currentField.controlType != "datepicker" &&
                currentField.getListFrom == undefined
            ) {
                dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
            }
            return null;
        });

        dataToReset[fieldName] = newValue;
        this.setState({
            fieldData: dataToReset,
        });
    };

    render() {
        const { dynamicMasterData, fieldData, formErrors } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        padding: 2,
                    }}
                    elevation={0}
                >
                    <DynamicFormWithoutValidation
                        dynamicMasterData={dynamicMasterData}
                        getListById={this.getListById}
                        showBackToList={true}
                        showSaveBtn={true}
                        showSaveBtnMain={false}
                        screenTitle={"Optional Holiday Under Team"}
                        fieldMeta={OptionalHolidayJson.fieldMetaForSalesTeam}
                        apiBaseURL={OptionalHolidayJson.apiBaseURL}
                        saveBtnText={"Submit"}
                        onFormSave={this.onFormSave}
                        onDataChange={this.onDataChange}
                        fieldData={fieldData}
                        formErrors={formErrors}
                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    optionalHolidayList: state.year,
    salesTeamList: state.salesExecutive,

});
const mapDispatchToProps = {
    getAvailableOptionalHolidays,
    getBelowSalesTeamList,
    showLoador,
    showNotification,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(AddOptionalHolidayForUnderTeam);
